import axios, { AxiosRequestConfig } from "axios";

export const hangExperienceEnterVTO = async () => {
  const url = `${process.env.REACT_APP_GCP_BASE_URL}/innovation/api/nft/v1/activity`;
  const uid = localStorage.getItem("uid") || null;
  const page = new URLSearchParams(location.search).get("page");

  const actionID = (() => {
    switch (page) {
      case "vto-volume":
        return "VT";
      case "vto-color":
        return "CT";
      case "vto-styles":
        return "ST";
      case "vto-analysis":
        return "HA";
      default:
        return null;
    }
  })();

  if (uid && actionID) {
    const axiosConfig: AxiosRequestConfig = {
      url: url,
      method: "POST",
      headers: {
        "x-api-key": process.env.REACT_APP_HANG_EXPERIENCE_API_KEY,
        "Content-Type": "application/json",
      },
      data: {
        uid: uid,
        actionId: actionID,
        application: "6",
      },
    };

    try {
      const response = await axios(axiosConfig);
      return response;
    } catch (error) {}
  }
};
